module.exports = __webpack_public_path__ + "static/media/floor_wooden_panel.9d29aafb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/floor_wooden_panel.png
 ** module id = 956
 ** module chunks = 0
 **/